import { defaultState } from './state';

export default {
  SET_CLEAR_STATE: (state) => {
    Object.assign(state, defaultState());
  },
  SET_OFFER_ID: (state, value) => { state.offerId = value; },
  SET_SHOWN: (state, value) => { state.isShown = value; },
  SET_LOADING: (state, value) => { state.privateOffersLoading = value; },
  SET_NAME: (state, value) => { state.formData.name = value; },
  SET_BOTTOM_BANNER: (state, value) => { state.formData.bottomBanner = value ?? null; },
  SET_TOP_BANNER: (state, value) => { state.formData.topBanner = value ?? null; },
  SET_BOTTOM_BANNER_ID: (state, value) => { state.formData.bottomBannerId = value ?? null; },
  SET_TOP_BANNER_ID: (state, value) => { state.formData.topBannerId = value ?? null; },
  SET_SLUG: (state, value) => { state.formData.slug = value; },
  SET_MANAGER: (state, value) => { state.formData.manager = value; },
  SET_SERVICES: (state, services) => {
    state.formData.services = services.map((discountService) => ({
      ...discountService,
      isSavedOnServer: true,
    }));
  },
  SET_VALID_FROM: (state, value) => { state.formData.validFrom = value; },
  SET_VALID_TO: (state, value) => { state.formData.validTo = value; },
  SET_CREATED_AT: (state, value) => { state.formData.createdAt = value; },
  SET_COUNTDOWN_ENABLED: (state, value) => { state.formData.isCountdownEnabled = value; },
  SET_ERRORS: (state, value) => { state.errors = value; },
};
